export class ThemeColors {
    pageBackgroundColor?: string;
    headerColor?: string; 
    textColor?: string; 
    buttonColor?: string; 
    textHeadingColor?: string; 
}
